export const UPDATE_CARD = 'paymentPage/UPDATE_CARD';
